/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100).replace('.00', '');
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    if (comparing) {
      var res =  '<span class="is-size-9 has-text-medium-grey has-text-weight-normal">From </span><span class="has-text-red is-size-7 has-text-weight-medium">' + formatPrice(price) + '</span>';
      res +=
        ' <span class="is-size-9 has-text-black has-text-weight-normal">' +
        formatPrice(compare_at_price) +
        '</span>';
      res +=
        ' <span class="ais-hit--price-discount has-text-black is-size-9 has-text-weight-normal">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    } else {
      var res = formatPrice(price);
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return formatPrice(min) + ' - ' + formatPrice(max);
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    feefoReviews: function() {
        var firstSku = null;
        if (this.meta.reviews !== undefined) {
          if (this.meta.reviews.sku !== undefined) {
            var firstSku = this.meta.reviews.sku;
          } else {
            var firstSku = this.sku;
          }
        }
      return '<div class="feefo-product-stars-widget has-margin-bottom-small" data-product-sku="' + firstSku + '" data-parent-product-sku="'+ this.id +'"></div>';
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return formatPrice(min) + ' - ' + formatPrice(max);
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = this._highlightResult.title.value;
      // if (
      //   !this._distinct &&
      //   this.variant_title &&
      //   this.variant_title !== 'Default Title' &&
      //   this.variant_title !== 'Default'
      // ) {
      //   res += ' <span class="algolia-variant">(' + res + ')</span>';
      // }
      return res;
    },
    fullEscapedAttribute: function fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = algolia.helpers.fullEscapedAttribute(
        this._highlightResult.title.value
      );
      // if (
      //   !this._distinct &&
      //   this.variant_title &&
      //   this.variant_title !== 'Default Title' &&
      //   this.variant_title !== 'Default'
      // ) {
      //   res += ' <span class="algolia-variant">(' + res + ')</span>';
      // }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.product_type.value
      );
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.vendor.value
      );
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    // Metafield Helpers
    usp: function usp () {
      var usp = null;
      if (this.meta.accentuate !== undefined) {
       if (this.meta.accentuate.usp != undefined) {
          var usp = this.meta.accentuate.usp;
        }
      }
      return usp;
    },
    // Metafield Helpers
    firstSKU: function sku () {
      var firstSku = null;
      if (this.meta.reviews !== undefined) {
        if (this.meta.reviews.sku !== undefined) {
          var firstSku = this.meta.reviews.sku;
        } else {
          var firstSku = this.sku;
        }
      }
      return firstSku;
    },
    labelText: function labelText () {
      var label = null;
      var label_text_colour = null;

      if (this.meta.accentuate !== undefined) {
       if (this.meta.accentuate.label_text != undefined) {
         if (this.meta.accentuate.label_text_colour != undefined) {
           var label_text_colour = this.meta.accentuate.label_text_colour;
         } else {
          var label_text_colour = '#000000'
         }

         if (this.meta.accentuate.label_bg_colour != undefined) {
           var label_bg_colour = this.meta.accentuate.label_bg_colour;
         } else {
          var label_bg_colour = '#FFFFFF'
         }

         let moneyoff = ""
         if (this.price < this.compare_at_price) {
           moneyoff = formatPrice(this.compare_at_price - this.price) + " IN MENO ";
         }

         this.meta.accentuate.label_text = this.meta.accentuate.label_text.replace('[moneyoff]', moneyoff);

         var label =  "<span class='product-list-item__label is-uppercase is-size-9' style='color:" + label_text_colour + "; background-color:" + label_bg_colour + "'>" + this.meta.accentuate.label_text + "</span>";
        }
      }
      return label;
    },
    mainImage: function mainImage () {
      var imageStr = null;
      if (this.meta !== undefined && this.meta.accentuate !== undefined && this.meta.accentuate.main_image != undefined && JSON.parse(this.meta.accentuate.main_image).length > 0) {
        var imageSrc = JSON.parse(this.meta.accentuate.main_image)[0].cloudinary_src;
        var imageSrc = imageSrc + 'w_380,h_463,c_fill';
      } else {
        var image = this._distinct ? this.product_image : this.image;
        if (!image) {
          var imageSrc = 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        } else {
          var imageSrc = image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '380x463_crop_center' + '.$2');
        }
      }

      if (imageSrc) {
        var imageStr = '<picture class="is-block">' +
          '<source media="(max-width: 768px)" srcset="'+imageSrc+'">' +
          '<source media="(max-width: 1023px)" srcset="'+imageSrc+'">' +
            '<img class="height-100 width-100 is-object-fit-cover is-block" src="'+imageSrc+'" srcset="'+imageSrc+'" alt="'+this.title+'"/>' +
        '</picture>';
      }
      return imageStr;
    },
    hasLifeStyleImage: function hasLifeStyleImage () {
      var className = null;
      if (this.meta !== undefined && this.meta.accentuate !== undefined && this.meta.accentuate.lifestyle_image != undefined) {
        var className = 'has-lifestyle-image';
      }
       return className;
    },
    lifeStyleImage: function lifeStyleImage () {
      var image = null;
      if (this.meta !== undefined && this.meta.accentuate !== undefined && this.meta.accentuate.lifestyle_image != undefined &&  JSON.parse(this.meta.accentuate.lifestyle_image).length > 0) {
         var imageSrc = JSON.parse(this.meta.accentuate.lifestyle_image)[0].cloudinary_src;
         var image = '<div class="product-list-item__image-lifestyle">' +
                      '<img class="height-100 width-100 is-object-fit-cover" src="'+ imageSrc + '" />' +
                     '</div>'
         }
       return image;
    },
    options: function options () {
      var options = null;
      if (this.variants_count > 1) {
        var options = this.variants_count + ' Options Available';
      }
      return options;
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
